import React, { useState } from 'react';
import { useGetDocuments } from '../../../../../../Hooks/TT_ELD/TruckInfo';
import { useParams } from 'react-router-dom';
import { Button, Col, Select, Spin, Table, TableProps } from 'antd';
import { truckInfo } from '../../../../../../API/TT_ELD/Users/truckInfo';
import DownloadButton from './DownloadButton';
import SearchOptions from '../../../../../../Utils/SearchOptions';
import {
  SearchResultForCompany,
  SearchResultForFindDriver,
} from '../../../../../../Utils/SearchResults';
import SearchInput from '../../../../../../Utils/SearchInput';
import useRouteQuery from '../../../../../../Utils/useRouterQuery';
import { sendEvent } from '../../../../../../Utils/analytics';
import { calcOrder } from '../../../../../components/core/calcOrder';
import dayjs from 'dayjs';
import { TableParams } from '../../../../../../Utils/TableTypes';
import { useTagQuerySync } from '../../../../../../Utils/useTagQuerySync';

const { Option } = Select;

type Data = {
  data?: {
    data: Array<any>;
    count: number;
  };
  isLoading?: boolean;
  refetch?: any;
  isFetching?: boolean;
};

interface userDataSource {
  id: number | string;
  name: string;
  company: number | string;
  type: number | string;
  createdAt: number | string;
  edit: [];
  key: React.Key;
}

interface Params {
  id: string | undefined | any;

  [key: string]: string | undefined;
}

const Documents = () => {
  const { id } = useParams<Params>();
  const [companyName, setCompanyName] = useRouteQuery('', 'companyName', String);
  const [companyId, setCompanyId] = useState<number | string>('');
  const [userName, setUserName] = useRouteQuery('', 'userName', String);
  const [userId, setUserId] = useState<undefined | number | string>('');
  const [type, setType] = useRouteQuery('', 'type', (v) => String(v));
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  useTagQuerySync(
    { en_US: 'Documents', zh_CN: '' },
    'documents',
    { companyName, companyId, userName, userId, type, tableParams },
    {
      companyName: setCompanyName,
      companyId: setCompanyId,
      userId: setUserId,
      userName: setUserName,
      type: setType,
      tableParams: setTableParams,
    },
  );

  const [value, setValue] = useState<string>();

  const [logType, setLogType] = useState<string>();
  const [date, setDate] = useState<string>();

  const dateOptions = Array.from({ length: 11 }, (_, i) => {
    const d = dayjs().subtract(i, 'day');
    return {
      label: d.format('DD-MM-YYYY'),
      value: d.format('DD-MM-YYYY'),
    };
  });

  const showDateSelect =
    logType === 'upload_eld_log_file' ||
    logType === 'upload_log_file' ||
    logType === 'upload_action_log_file' ||
    logType === 'upload_error_log_file' ||
    logType === 'upload_protrux_logs';

  const handleUpload = () => {
    if (logType) {
      sendCommandAndRefetch(logType, date);
    }
  };

  const { data, refetch, isLoading, isFetching }: Data = useGetDocuments(
    id,
    userId,
    companyId,
    type,
    tableParams,
  );
  const columns: object[] = [
    {
      title: 'No',
      dataIndex: 'id',
      key: 'id',
      width: 65,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Download',
      dataIndex: 'edit',
      key: 'edit',
      width: 200,
      render: (links: any) => {
        return (
          <>
            {links.map((link: any) => (
              <DownloadButton key={link?.link} link={link?.link} fileName={link?.fileName} />
            ))}
          </>
        );
      },
    },
  ];

  const sendCommandAndRefetch = async (command: string, date?: string) => {
    await truckInfo.commandsPost({
      command: command,
      userId: id,
      extra: date ? { date } : undefined,
    });
    sendEvent('Documents Tab ', `Documents Button  ${command} `, `Button Clicked `, 1);

    refetch();
  };

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      type: setType,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event?.trim());
      setTableParams({
        pagination: {
          current: 1,
        },
      });
    }
  };

  const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  const handleSearchSelect =
    (setter: (val: string) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      if (valId) {
        setTableParams({
          pagination: {
            current: 1,
          },
        });
      }
    };

  return (
    <div className="mainPage">
      <Spin size="large" spinning={isLoading || isFetching}>
        {!id && (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '15px',
            }}
          >
            <SearchOptions
              SearchResult={SearchResultForCompany}
              onSelect={handleSearchSelect(setCompanyId, setCompanyName)}
              placeholder="Search by company"
              value={companyName}
            />
            <SearchOptions
              SearchResult={(query: string) => SearchResultForFindDriver(query)}
              onSelect={handleSearchSelect(setUserId, setUserName)}
              placeholder="User Search"
              value={userName}
            />

            <SearchInput
              value={type}
              placeholder="Type Search"
              onDebounceChange={(event: string) => handleChange(event, 'type')}
            />

            <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={() => refetch()}>
              Refresh
            </Button>
          </span>
        )}
        <Col style={{ margin: '0px 0 15px 0' }}>
          {id && (
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  width: '40%',
                }}
              >
                {/* <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_log_file')}
                >
                  Request Log
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_db_file')}
                >
                  Request DB
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_timer_file')}
                >
                  Upload Timer File
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('delete_db_file')}
                >
                  Delete DB File
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_pref_file')}
                >
                  Upload Pref File
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_screenshot_file')}
                >
                  Upload Screenshot File
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => sendCommandAndRefetch('upload_eld_log_file')}
                >
                  Upload ELD log file
                </Button>

                 */}

                <Select
                  placeholder="Select Log Type"
                  style={{ width: 220 }}
                  value={logType}
                  onChange={(val) => {
                    setLogType(val);
                    setDate(undefined);
                  }}
                >
                  <Option value="upload_log_file">Get API Log File</Option>
                  <Option value="upload_db_file">Get DB File</Option>
                  <Option value="upload_timer_file">Get Timer File</Option>
                  <Option value="delete_db_file">Delete DB File</Option>
                  <Option value="upload_pref_file">Get Pref File</Option>
                  <Option value="upload_screenshot_file">Get Screenshot</Option>
                  <Option value="upload_eld_log_file">Get ELD Log File</Option>

                  <Option value="upload_action_log_file">Get Action Log File</Option>
                  <Option value="upload_error_log_file">Get Error Log File</Option>
                  <Option value="upload_protrux_logs">Get ProTRUX Logs</Option>
                </Select>

                {showDateSelect && (
                  <Select
                    placeholder="Select date"
                    style={{ width: 160 }}
                    value={date}
                    onChange={setDate}
                  >
                    {dateOptions.map((d) => (
                      <Option key={d.value} value={d.value}>
                        {d.label}
                      </Option>
                    ))}
                  </Select>
                )}

                <Button
                  type="primary"
                  onClick={handleUpload}
                  disabled={!logType || (showDateSelect && !date)}
                >
                  Confirm
                </Button>
              </div>

              <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={() => refetch()}>
                Refresh
              </Button>
            </span>
          )}
        </Col>

        <Table
          onChange={handleTableChange}
          dataSource={data?.data?.map((u: any, i: number): userDataSource => {
            const obj: userDataSource = {
              id: calcOrder(tableParams.pagination?.current ?? 1, 10, i),
              name: u?.user.first_name + ' ' + u?.user.second_name,
              company: u.company?.name + ' : ' + u?.company?.id,
              type: u.type,
              createdAt: u.createdAt,
              edit: u.links,
              key: u.id,
            };
            return obj;
          })}
          columns={columns}
          pagination={{
            total: data?.count,
            showSizeChanger: false,
            current: tableParams.pagination?.current,
          }}
          scroll={{ x: 1000 }}
          sticky
        />
      </Spin>
    </div>
  );
};

export default Documents;
